var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M496.131 435.698 374.855 332.551c-12.537-11.283-25.945-16.463-36.776-15.963C366.707 283.054 384 239.549 384 192 384 85.961 298.039 0 192 0 85.962 0 0 85.961 0 192s85.961 192 192 192c47.549 0 91.054-17.293 124.588-45.922-.5 10.831 4.68 24.239 15.963 36.776L435.698 496.13c17.661 19.623 46.511 21.277 64.11 3.678s15.946-46.449-3.677-64.11zM192 320c-70.692 0-128-57.308-128-128S121.308 64 192 64s128 57.308 128 128-57.307 128-128 128z"}));
}

Search.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Search;

Search.default = Search;
